import cruise from './cruise';
import verona from './verona';
import galata from './galata';
import octavia_assets from './octavia_assets';
import powell_assets from './powell_assets';
import milky_way_assets from './milky_way_assets';
import camden_assets from './camden_assets';
import lewis_assets from './lewis';
import blake_border from './blake_border';

export default {
  cruise,
  verona,
  galata,
  octavia_assets,
  powell_assets,
  milky_way_assets,
  camden_assets,
  lewis_assets,
  blake_border,
};
